import { useQuery } from "@tanstack/react-query";

import { getReconMe, RECON_ME_QUERY_KEY, type ShellReconMeResponse } from "./api";

export function useReconMeQuery(enabled: boolean) {
  return useQuery<ShellReconMeResponse>({
    queryKey: RECON_ME_QUERY_KEY,
    queryFn: ({ signal }) => getReconMe({ signal }),
    enabled,
    retry: false,
    staleTime: 30_000,
  });
}
